
$(document).ready(function () {
    'use strict';

    // ==========================================
    // FLOATING SAME DAY DELIVERY COUNTDOWN
    // ==========================================

    var cutoffHour = 13; // 1:00 PM Sydney time
    var timeZone = 'Australia/Sydney';

    var lastScrollTop = $(window).scrollTop();
    var scrollTimeout = null;

    // ==========================================
    // ADD CSS
    // ==========================================

    if (!$('#floating-countdown-style').length) {
        $('head').append(`
            <style id="floating-countdown-style">

                #floating-delivery-countdown {
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    box-sizing: border-box;
                    background: #f7f5f3;
                    padding: 14px 20px;
                    text-align: center;
                    font-size: 15px;
                    color: #333;
                    z-index: 99999;
                    box-shadow: 0 -2px 10px rgba(0,0,0,0.08);
                    font-family: inherit;

                    /* Smooth scroll animation */
                    transform: translateY(0);
                    opacity: 1;
                    transition:
                        transform 0.35s ease,
                        opacity 0.35s ease;

                    animation: countdownEntrance 0.6s ease-out;
                }

                /* Scroll down: slightly lower and fade */
                #floating-delivery-countdown.scrolling-down {
                    transform: translateY(12px);
                    opacity: 0.85;
                }

                /* Scroll up: slightly lift */
                #floating-delivery-countdown.scrolling-up {
                    transform: translateY(-5px);
                    opacity: 1;
                }

                /* Initial entrance */
                @keyframes countdownEntrance {
                    from {
                        transform: translateY(100%);
                        opacity: 0;
                    }

                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }

                #floating-delivery-countdown .countdown-time {
                    display: inline-block;
                    background: #fff;
                    color: #4c347f;
                    padding: 5px 9px;
                    border-radius: 5px;
                    font-weight: 700;
                    margin: 0 5px;
                    font-variant-numeric: tabular-nums;
                }
                
                .purple-link {
                    color: #4c347f;
                    font-weight:bold;
                    text-decoration:underline;
                    text-underline-offset: 5px;
                }

                @media (max-width: 768px) {
                    #floating-delivery-countdown {
                        font-size: 13px;
                        padding: 12px 8px;
                    }

                    #floating-delivery-countdown .countdown-time {
                        padding: 4px 6px;
                        margin: 0 3px;
                    }
                }

                @media (prefers-reduced-motion: reduce) {
                    #floating-delivery-countdown {
                        animation: none;
                        transition: none;
                    }
                }

            </style>
        `);
    }

    // ==========================================
    // INSERT FLOATING BAR
    // ==========================================

    if (!$('#floating-delivery-countdown').length) {
        $('body').append(`
            <div id="floating-delivery-countdown"
                 role="status"
                 aria-live="off">
                <span id="floating-countdown-message">
                    Checking delivery cutoff...
                </span>
            </div>
        `);
    }

    var $countdown = $('#floating-delivery-countdown');

    // ==========================================
    // GET CURRENT SYDNEY TIME
    // ==========================================

    function getSydneyTime() {
        var parts = new Intl.DateTimeFormat('en-AU', {
            timeZone: timeZone,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23'
        }).formatToParts(new Date());

        var values = {};

        parts.forEach(function (part) {
            if (part.type !== 'literal') {
                values[part.type] = Number(part.value);
            }
        });

        return values;
    }

    // ==========================================
    // UPDATE COUNTDOWN
    // ==========================================

    function updateCountdown() {
        var $message = $('#floating-countdown-message');

        if (!$message.length) {
            return;
        }

        var now = getSydneyTime();

        var currentSeconds =
            now.hour * 3600 +
            now.minute * 60 +
            now.second;

        var cutoffSeconds = cutoffHour * 3600;
        var remaining = cutoffSeconds - currentSeconds;

        // AFTER 1:00 PM SYDNEY TIME
        if (remaining <= 0) {
            $message.html(
                'Same-day delivery has closed for today. Missed the cutoff? <a class="purple-link" href="/collections/boxes">Order now</a> for next day delivery!'
            );
            return;
        }

        // BEFORE 1:00 PM
        var hours = Math.floor(remaining / 3600);
        var minutes = Math.floor(
            (remaining % 3600) / 60
        );
        var seconds = remaining % 60;

        var countdown =
            hours + 'h ' +
            String(minutes).padStart(2, '0') + 'm ' +
            String(seconds).padStart(2, '0') + 's';

        $message.html(
            'Order within ' +
            '<span class="countdown-time">' +
            countdown +
            '</span>' +
            ' for same day delivery.'
        );
    }

    // ==========================================
    // SCROLL ANIMATION
    // ==========================================

    $(window).on('scroll', function () {

        var currentScrollTop = $(window).scrollTop();

        // Ignore tiny scroll movements
        if (Math.abs(currentScrollTop - lastScrollTop) < 3) {
            return;
        }

        $countdown.removeClass(
            'scrolling-up scrolling-down'
        );

        if (currentScrollTop > lastScrollTop) {

            // User scrolling down
            $countdown.addClass('scrolling-down');

        } else {

            // User scrolling up
            $countdown.addClass('scrolling-up');
        }

        lastScrollTop = currentScrollTop;

        // Return bar to normal after scrolling stops
        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(function () {
            $countdown.removeClass(
                'scrolling-up scrolling-down'
            );
        }, 250);

    });

    // ==========================================
    // INITIALIZE
    // ==========================================

    updateCountdown();

    // Update every second
    setInterval(updateCountdown, 1000);

});
